<template>
  <article class="note-item">
    <component
      :is="comp"
      :note="note"
      :user-id="userId"
      :membership="membership"
      :public-mode="publicMode"
      @toggle-select="onToggleSelect"
      @tag-selected="onSelectTag"
      @favorite="onAction('favorite', $event)"
      @save="onAction('save', $event)"
      @add-to-collection="onAction('add-to-collection', $event)"
      @add-to-collection-from-collection="onAction('add-to-collection-from-collection', $event)"
      @comments="onAction('comments', $event)"
      @like="onAction('like', $event)"
      @likes="onAction('likes', $event)"
      @pin-edit="onAction('pin-edit', $event)"
    />
  </article>
</template>

<script setup>
import { computed, defineProps, defineEmits } from 'vue'
import { ITEM_LAYOUT_STYLE } from '@/utils/constants'
import NoteCard from './notes/NoteCard.vue'
import NoteListItem from './notes/NoteListItem.vue'
import NoteHeadline from './notes/NoteHeadline.vue'
import NoteTile from './notes/NoteTile.vue'

const props = defineProps({
  note: {
    type: Object,
    required: true,
  },
  userId: {
    type: String,
    default: null,
  },
  membership: {
    type: Object,
    default: null,
  },
  listStyle: {
    type: String,
    default: 'card',
  },
  publicMode: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['action', 'filter-tags'])

const STYLES = {
  [ITEM_LAYOUT_STYLE.cards]: NoteCard,
  [ITEM_LAYOUT_STYLE.list]: NoteListItem,
  [ITEM_LAYOUT_STYLE.headlines]: NoteHeadline,
  [ITEM_LAYOUT_STYLE.tiles]: NoteTile,
}

const comp = computed(() => STYLES[props.listStyle])

function onSelectTag(tag) {
  emit('filter-tags', tag.id || tag._id)
}

function onAction(action, event) {
  emit('action', { action, event })
}

function onToggleSelect(event) {
  emit('action', { action: 'toggle-select', event })
}
</script>
